import uuid from 'react-uuid';
import {
  validateMatch, generateS3FileName, encryptPayload,
} from '../utils/util';
import {
  fetchS3Data, saveDataToS3, checkReviewPortalStatus,
} from '../utils/utilService';

const setVal = require('lodash/set');

const setStatusForReviewPortal = (paramters, formSubmissionPayload) => {
  const {
    iformReviewInfo, partialSubmit, s3Operations, tempBody,
    reviewStatus,
  } = paramters;
  if (iformReviewInfo) {
    if (partialSubmit || reviewStatus) {
      if (reviewStatus) {
        tempBody.status = reviewStatus;
      } else if (formSubmissionPayload.status === 'SIGNATURE' || formSubmissionPayload.status === 'FORM_DOWNLOADED') {
        tempBody.status = formSubmissionPayload.signatureType;
      } else if (formSubmissionPayload.isDocIdPresentInUrl === 'Yes' && formSubmissionPayload.status !== 'PARTIALLY_SAVE') {
        tempBody.status = 'RE_SUBMITTED';
      } else {
        tempBody.status = 'OPEN';
      }
    } else {
      tempBody.status = 'PARTIALLY_SAVE';
    }

    tempBody.indexData = generateS3FileName(tempBody, s3Operations.fileNameParameters);

    if (s3Operations?.appendToS3PayloadOtherInfo) {
      if (typeof tempBody.s3PayloadOtherInfo === 'undefined') {
        tempBody.s3PayloadOtherInfo = {};
      }
      tempBody.s3PayloadOtherInfo = {
        ...tempBody.s3PayloadOtherInfo,
        ...s3Operations.appendToS3PayloadOtherInfo,
      };
    }
  }
  return tempBody;
};

const useS3Operations = ({
  formContainer,
  iformIntegrationUrls,
  cuid,
  journeyId,
  appBaseUrls,
  loggerApiCall,
  formSubmissionPayload,
  setFormSubmissionPayload,
  setIsFormSubmission,
  entityData,
  setEntityData,
  allS3FileIds,
  setAllS3FileIds,
  s3FileInfo,
  setS3FileInfo,
  s3EsignFileInfo,
  setComments,
  setReviewComments,
  setEntityComments,
  setS3PayloadOtherInfo,
  objectOfFunctions,
  handleContinue,
}) => {
  const getS3Data = async () => {
    const s3Operations = formContainer.operations.fetchS3Data;

    // Check review portal enable status
    const requestObj = {
      iformIntegrationUrls,
      pageType: formContainer.pageType,
      cuid,
      journeyId,
    };
    const isReviewPortalEnabled = await checkReviewPortalStatus(requestObj);

    let id = null;
    if (s3Operations.nextPage) {
      id = 'continue';
    }
    // check if formSubmissionPayload already has value --> s3DataFetchStatus
    // data already fetched in this session
    // No need to make api call again --> handleContinue --> update elemId only
    // call api and below code
    if (formSubmissionPayload && formSubmissionPayload.s3DataFetchStatus) {
      setFormSubmissionPayload({ ...formSubmissionPayload, elemId: id });
    } else {
      setIsFormSubmission(true);
      const requestPayload = {
        head: {
          traceId: uuid(),
          span: 'iForm6513',
          journeyId,
        },
        body: {
          docKey: formSubmissionPayload[s3Operations.s3DocIdKey],
          encryptedPasscode: formSubmissionPayload[s3Operations.pw],
        },
      };

      const paramsObj = {
        iformIntegrationUrls,
        pageType: formContainer.pageType,
        cuid,
        requestPayload,
      };
      const logString = 'status=calledS3DataFetchApi';
      loggerApiCall(logString, 'info');
      const response = await fetchS3Data(paramsObj, 'passcode', isReviewPortalEnabled);
      const data = await response.json();
      if (response.status === 200) {
        // update states with the data via JSON
        if (data && data.statusIndicator === 'T') {
          const logString1 = 'status=fetchS3DataApiCallSuccess';
          loggerApiCall(logString1, 'info');
          // update states via JSON?
          let states = JSON.parse(data.data);
          if (isReviewPortalEnabled) {
            states = JSON.parse(states.s3Payload);
          }
          setEntityData({ ...entityData, ...states.entityData });
          setAllS3FileIds([...allS3FileIds, ...states.allS3FileIds]);
          setS3FileInfo([...s3FileInfo, ...states.s3FileInfo]);
          // if it has review comments then initialise them
          if (states.reviewComments) {
            setComments({ ...states.reviewComments });
            // To keep the original comment data
            setReviewComments({ ...states.reviewComments });
          }
          if (states.entityComments) {
            setEntityComments([...states.entityComments]);
          }
          if (states.s3PayloadOtherInfo) {
            setS3PayloadOtherInfo({ ...states.s3PayloadOtherInfo });
          }
          setFormSubmissionPayload({
            ...formSubmissionPayload,
            ...states.formSubmissionPayload,
            elemId: id,
            dynamicClicDetails: states.dynamicClicDetails,
            s3DataFetchStatus: 1,
            s3DataFetchPasswordsMatchStatus: 1,
            status: states.status ? states.status : '',
          });
        } else if (data && data.statusIndicator === 'F' && isReviewPortalEnabled) {
          const logString1 = 'status=fetchS3DataApiCallFailedDueToIncorrectPasscode';
          loggerApiCall(logString1, 'info');
          setFormSubmissionPayload({
            ...formSubmissionPayload,
            ...{ elemId: 'continue', s3DataFetchPasswordsMatchStatus: 0 },
          });
        }
      } else if (response.status === 401) {
        const logString1 = `status=fetchS3DataApiCallFailed errorMsg=${data.message}`;
        loggerApiCall(logString1, 'error');
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{ elemId: null, s3DataFetchPasswordsMatchStatus: 0 },
        });
      } else {
        const logString1 = `status=fetchS3DataApiCallFailed errorMsg=${data.message}`;
        loggerApiCall(logString1, 'error');
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          elemId: null,
          s3DataFetchPasswordsMatchStatus: 1,
          s3DataFetchStatus: 0,
        });
      }
      setIsFormSubmission(false);
    }
  };

  const putDataToS3 = async (partialSubmit = false, file = null, reviewStatus = null) => {
    // check if s3passwords are matching?
    const s3Operations = formContainer.operations.addDataToS3;

    // Check review portal enable status
    const requestObj = {
      iformIntegrationUrls,
      pageType: formContainer.pageType,
      cuid,
      journeyId,
    };
    const isReviewPortalEnabled = await checkReviewPortalStatus(requestObj);
    let isValid = false;
    let isByPassPw = false;
    if (formSubmissionPayload.isDocIdPresentInUrl === 'Yes'
      && s3Operations.isByPassPwIfExist) {
      isValid = true;
      isByPassPw = true;
    } else if (validateMatch(
      formSubmissionPayload[s3Operations.pw1],
      formSubmissionPayload[s3Operations.pw2]
    ) || partialSubmit || reviewStatus) {
      isValid = true;
    }

    if (isValid) {
      // disable the buttons
      setIsFormSubmission(true);
      // create payload
      let tempBody = {};
      s3Operations.payloadFields.forEach((field) => {
        tempBody[field] = objectOfFunctions[field];
      });

      if (s3Operations?.removePayloadFields) {
        s3Operations.removePayloadFields.forEach((field) => {
          setVal(tempBody, field, {});
        });
      }

      // add esign file to original s3 array
      if (s3EsignFileInfo.length > 0) {
        tempBody.s3FileInfo = [...tempBody.s3FileInfo, s3EsignFileInfo[0]];
        tempBody.allS3FileIds = [...tempBody.allS3FileIds, s3EsignFileInfo[0].fileId];
      }

      const encryptedPasscode = !partialSubmit ? formSubmissionPayload[s3Operations.pw1] : '';

      // Set status for review portal
      tempBody = setStatusForReviewPortal({
        iformReviewInfo: isReviewPortalEnabled,
        partialSubmit,
        s3Operations,
        tempBody,
        reviewStatus,
      }, formSubmissionPayload);

      const requestPayload = {
        head: {
          traceId: uuid(),
          span: 'iForm6513',
          journeyId,
        },
        body: {
          ...tempBody,
          formSubmissionPayload: { ...tempBody.formSubmissionPayload },
          encryptedPasscode,
          docId: formSubmissionPayload[s3Operations.s3DocIdKey],
        },
      };
      // write keys to delete operation in JSON
      delete requestPayload.body.formSubmissionPayload[s3Operations.pw1];
      delete requestPayload.body.formSubmissionPayload[s3Operations.pw2];
      delete requestPayload.body.formSubmissionPayload.s3DataFetchStatus;
      delete requestPayload.body.formSubmissionPayload.isDocIdPresentInUrl;

      const formData = new FormData();

      // Attach fileData from Esign to payload
      if (file && partialSubmit) {
        formData.append('file', file);
      } else {
        formData.append('file', null);
      }

      formData.append('data', encryptPayload(requestPayload));
      const paramsObj = {
        iformIntegrationUrls,
        pageType: formContainer.pageType,
        cuid,
        formData,
      };

      const logString = 'status=calledS3DataSaveApi';
      loggerApiCall(logString, 'info');
      const data = await saveDataToS3(paramsObj, isReviewPortalEnabled);

      // Return in case of application download
      if (reviewStatus) {
        setIsFormSubmission(false);
        return;
      }
      if (data && data.statusIndicator === 'T') {
        const logString1 = 'status=s3DataSaveApiCallSuccess';
        loggerApiCall(logString1, 'info');
        if (isReviewPortalEnabled) {
          loggerApiCall('page=thankyou operation=reviewPortal_submission', 'info');
        }
        const pageType = s3Operations.newUrlPageType || formContainer.pageType;
        const generatedUrl = `${appBaseUrls}/iForms/${pageType}/${paramsObj.cuid}?docId=${formSubmissionPayload[s3Operations.s3DocIdKey]}`;
        formSubmissionPayload.s3DataSaveStatus = 1;
        let id = null;
        if (s3Operations.nextPage && !isByPassPw) {
          id = 'continue';
        }
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{
            elemId: id, s3DataSavePasswordsMatchStatus: 1, s3DataSaveStatus: 1, generatedUrl,
          },
        });
        setIsFormSubmission(false);

        if (isByPassPw) {
          handleContinue(s3Operations?.byPassPwNextPage);
        }

        // call logger
      } else {
        const logString1 = `status=s3DataSaveApiCallFailed errorMsg=${data.message}`;
        loggerApiCall(logString1, 'error');
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{ elemId: null, s3DataSaveStatus: 0, s3DataSavePasswordsMatchStatus: 1 },
        });
      }
      setIsFormSubmission(false);
    } else {
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        ...{ elemId: null, s3DataSavePasswordsMatchStatus: 0 },
      });
      setIsFormSubmission(false);
    }
  };

  return { getS3Data, putDataToS3 };
};

export default useS3Operations;
